const Pink = {
  Pink: {
    _100: '#FCE7F3',
    _500: '#EC4899',
  },
};

export default Pink;
